import { Box } from '@mui/material'
import cx from 'classnames'

import DoubleNumberInput from './components/DoubleNumberInput'

import useStyles from './style'

const FixedBidControls = ({
  displayControls,
  fixedExactValue,
  fixedPhraseValue,
  fixedBoardValue,
  onFixedBidExactUpdate = () => {},
  onFixedBidPhraseUpdate = () => {},
  onFixedBidBoardUpdate = () => {},
  isBol = true,
}) => {
  const classes = useStyles()

  if (!displayControls) return null

  return (
    <Box className={cx(classes.box)}>
      <DoubleNumberInput label="Fixed exact bid" value={fixedExactValue} onChange={onFixedBidExactUpdate} />
      <DoubleNumberInput label="Fixed phrase bid" value={fixedPhraseValue} max={5} onChange={onFixedBidPhraseUpdate} />
      {!isBol && <DoubleNumberInput label="Fixed Board Bid" value={fixedBoardValue} onChange={onFixedBidBoardUpdate} />}
    </Box>
  )
}

export default FixedBidControls
